import { useRef } from 'react';

import { getPlaceholderHtml as getEmailPlaceholderHtml } from '@components/email-field/extensions';
import { Form } from '@components/form';
import { IconAddPlus } from '@components/icons/add-plus';
import { PopoverButton } from '@components/popover-button';
import { useScopedTranslate } from '@locale/translate';
import { pxToRem } from '@utils/converters';
import { uuid } from '@utils/uuid';

import { EditorRefProp } from '../common';
import { locale } from '../field-mapping-sidebar';

export const EmailManualField = ({ editorRef }: EditorRefProp) => {
  const { t } = useScopedTranslate(locale);
  const fieldId = useRef(uuid()).current;
  return (
    <PopoverButton
      placement="bottom-start"
      triggerProps={{
        iconLeft: <IconAddPlus />,
        variant: 'secondary',
        text: t('addEmail'),
      }}
      contentStyle={{ maxWidth: pxToRem(392) }}
    >
      {({ close }) => (
        <Form
          onSubmit={(values) => {
            const value = String(values[fieldId] ?? '').trim();
            if (!value) return;
            editorRef.current?.insertContent(getEmailPlaceholderHtml({ value }));
            close();
          }}
        >
          <Form.EmailTextField id={fieldId} label={t('emailLabel')} autoFocus />
          <Form.Actions>
            <Form.Reset text={t('core.cancel')} onClick={() => close()} />
            <Form.Submit variant="primary-blue" text={t('core.add')} iconLeft={<IconAddPlus />} />
          </Form.Actions>
        </Form>
      )}
    </PopoverButton>
  );
};
